import { useIntl } from 'react-intl';
import { useEventGeneratorClickCta } from 'src/analytics/useEventGeneratorClickCta';
import { Button } from 'src/components';
import { useCtaHref } from 'src/hooks/useCtaHref';
import { useTargetMessages } from 'src/hooks/useTargetMessages';
import PIB_1 from 'images/pib_1.png';
import PIB_2 from 'images/pib_2.png';
import PIB_3 from 'images/pib_3.png';
import MarketingMessageCard from '../MarketingMessageCard';
import * as S from './styles';
import * as msgsData from './messages';

const { msgs, ...localesWithMessages } = msgsData;

const MarketingMessage = () => {
  const intl = useIntl();
  const targetMsgs = useTargetMessages(localesWithMessages);

  const signUpHref = useCtaHref();
  const eventGeneratorClickCta = useEventGeneratorClickCta();

  return (
    <S.Container>
      <S.Title>{intl.formatMessage(targetMsgs.marketingSectionTitle)}</S.Title>
      <S.SubTitle>{intl.formatMessage(msgs.communicateDescription)}</S.SubTitle>
      <S.BlockItems>
        <MarketingMessageCard
          image={PIB_1}
          $type="learn"
          title={intl.formatMessage(msgs.learnTitle)}
          description={intl.formatMessage(msgs.learnMarketingDescription)}
        />
        <MarketingMessageCard
          image={PIB_2}
          $type="immerse"
          title={intl.formatMessage(msgs.immerseTitle)}
          description={intl.formatMessage(msgs.immerseMarketingDescription)}
        />
        <MarketingMessageCard
          image={PIB_3}
          $type="communicate"
          title={intl.formatMessage(msgs.communicateTitle)}
          description={intl.formatMessage(msgs.communicateMarketingDescription)}
        />
      </S.BlockItems>
      <S.CTA>
        <Button
          analyticsEvent={eventGeneratorClickCta}
          buttonSizeBreakpoint="md"
          buttonType="primary"
          disableMinWidth
          fullWidth="never"
          href={signUpHref}
        >
          {intl.formatMessage(targetMsgs.ctaButton)}
        </Button>
      </S.CTA>
    </S.Container>
  );
};

export default MarketingMessage;
